
(function(){
  var S = location.search;
  function has(k){ return new RegExp('[?&]'+k+'=1').test(S); }

  var FAQ_COMMON = [
    { q: 'Quels sont les délais de livraison ?', a: 'Livraison en 7 à 10 jours ouvrés, expédiée sous 24 à 48 h. Livraison offerte, sans minimum d\'achat.' },
    { q: 'Puis-je retourner mon produit ?', a: 'Oui, retours acceptés sous 15 jours.' },
    { q: 'Puis-je payer en plusieurs fois ?', a: 'Oui, paiement en plusieurs fois avec Alma, et paiement 100% sécurisé.' }
  ];
  var FAQ_INFLATE_PADDLE = { q: 'Comment le gonfler ?', a: 'Avec la pompe fournie dans le pack, sans accessoire supplémentaire.' };
  function faq(specific){ return specific.concat(FAQ_COMMON); }
  /* (14) FAQ IN-FORM : liste FIXE COURTE de 4 questions BASIQUES, identique pour tous les produits (les questions specifiques produit vont dans une section FAQ bas de page separee). */
  var FAQ_BASIC = [
    { q: 'Quels sont les délais de livraison ?', a: 'Livraison en 7 à 10 jours ouvrés, expédiée sous 24 à 48 h. Livraison offerte, sans minimum d\'achat.' },
    { q: 'Puis-je retourner mon produit ?', a: 'Oui, retours acceptés sous 15 jours.' },
    { q: 'Puis-je payer en plusieurs fois ?', a: 'Oui, paiement en plusieurs fois avec Alma, et paiement 100% sécurisé.' },
    { q: 'Le produit est-il garanti ?', a: 'Oui, il bénéficie de la garantie légale de conformité de 2 ans.' }
  ];
  var FAQ_MAP = {
    'paddle-gonflable-sunset': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 335 × 84 × 15 cm, pour un poids de planche de 11,5 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 1 aileron, leash, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 165 kg, adaptée à la plupart des gabarits.' },
      { q: 'Convient-il aux débutants ?', a: 'Oui, ce modèle de niveau débutant et son format 335 cm en font une planche accessible pour une première pratique du stand up paddle.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-papillon': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 335 × 83 × 15 cm, pour un poids de planche de 12,5 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 3 ailerons, leash, sac étanche, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 165 kg, convenant à la majorité des utilisateurs.' },
      { q: 'Convient-il aux débutants ?', a: 'Oui, ce paddle de niveau débutant offre la stabilité nécessaire pour apprendre sereinement le stand up paddle.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-marina': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 350 × 84 × 15 cm, pour un poids de planche de 11,5 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 1 aileron, leash, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 180 kg, adaptée à la plupart des pratiquants.' },
      { q: 'Convient-il aux débutants ?', a: 'Ce paddle est de niveau intermédiaire : il s\'adresse aux pratiquants ayant déjà quelques sorties à leur actif et souhaitant progresser en eau plate.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-tiki': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 320 × 84 × 15 cm, pour un poids de planche de 12,5 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 3 ailerons, leash, sangle d\'épaule, sac étanche, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 150 kg, pour une pratique loisir.' },
      { q: 'Convient-il aux débutants ?', a: 'Oui, son format 320 cm maniable de niveau débutant en fait un excellent choix pour découvrir le stand up paddle.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-koi': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 335 × 83 × 15 cm, pour un poids de planche de 12,5 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 3 ailerons, leash, sac étanche, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 165 kg, convenant à la plupart des gabarits.' },
      { q: 'Convient-il aux débutants ?', a: 'Oui, ce paddle de niveau débutant offre la stabilité nécessaire pour apprendre le stand up paddle en confiance.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-tropical': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 335 × 84 × 15 cm, pour un poids de planche de 13 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 1 aileron, leash, sac étanche, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 165 kg, convenant à la majorité des gabarits.' },
      { q: 'Convient-il aux débutants ?', a: 'Oui, ce paddle de niveau débutant offre la stabilité nécessaire pour découvrir le stand up paddle en confiance.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-tigre': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 350 × 90 × 15 cm, pour un poids de planche de 14,5 kg. Format large, pensé aussi pour 2 personnes.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, 2 pagaies, siège SUP, sac étanche 10 L, sangle d\'épaule, 3 ailerons, leash, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge généreuse de 200 kg, adaptée à une pratique à 2 personnes.' },
      { q: 'Convient-il aux débutants ?', a: 'Ce paddle est de niveau intermédiaire : il convient aux pratiquants déjà à l\'aise, en solo comme à deux, sur eau plate.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-pro': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 385 × 85 × 15 cm, pour un poids de planche de 14,5 kg. Grand format conçu pour une utilisation à deux.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, 2 pagaies, 3 ailerons, 2 leash, 2 sacs étanches, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge élevée de 230 kg.' },
      { q: 'Convient-il aux débutants ?', a: 'C\'est un modèle expert au grand format, davantage adapté aux pratiquants confirmés ou à une utilisation à deux. Les débutants seuls se tourneront plutôt vers un modèle plus court.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-dragon': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 350 × 84 × 15 cm, pour un poids de planche de 13 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 3 ailerons, leash, sac étanche, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 180 kg, adaptée à la plupart des pratiquants.' },
      { q: 'Convient-il aux débutants ?', a: 'Ce paddle est de niveau intermédiaire : il s\'adresse aux pratiquants ayant déjà quelques sorties à leur actif et souhaitant progresser en eau plate.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-floral': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 335 × 84 × 15 cm, pour un poids de planche de 12,3 kg.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, 3 ailerons, leash, sac étanche, sangle d\'épaule, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge de 165 kg, convenant à la plupart des gabarits.' },
      { q: 'Convient-il aux débutants ?', a: 'Oui, ce paddle de niveau débutant offre la stabilité nécessaire pour apprendre le stand up paddle sereinement.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-teak': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 350 × 89 × 15 cm, pour un poids de planche de 14,3 kg. Format large, idéal à deux.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, 2 pagaies, 3 ailerons, siège SUP, leash, sac étanche, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge très généreuse de 230 kg, adaptée à une pratique à 2 personnes.' },
      { q: 'Convient-il aux débutants ?', a: 'Ce paddle est de niveau intermédiaire : il convient aux pratiquants déjà à l\'aise, en solo comme à deux, sur eau plate.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-oak': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 350 × 89 × 15 cm, pour un poids de planche de 14,3 kg. Format large, idéal à deux.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, 2 pagaies, 3 ailerons, siège SUP, leash, sac étanche, pompe à main et sac à dos de transport.' },
      { q: 'Quel poids peut-il supporter ?', a: 'Capacité de charge très généreuse de 230 kg, adaptée à une pratique à 2 personnes.' },
      { q: 'Convient-il aux débutants ?', a: 'Ce paddle est de niveau intermédiaire : il convient aux pratiquants déjà à l\'aise, en solo comme à deux, sur eau plate.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-driftwood': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 350 × 86 × 15 cm, pensé pour une pratique en eau plate.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, ailerons, leash, sac étanche, pompe à main et sac à dos de transport.' },
      { q: 'Convient-il aux débutants ?', a: 'Ce paddle est de niveau intermédiaire : il s\'adresse aux pratiquants ayant déjà quelques sorties à leur actif et souhaitant progresser en eau plate.' },
      FAQ_INFLATE_PADDLE
    ]),
    'paddle-gonflable-nomad': faq([
      { q: 'Quelle est la taille de ce paddle ?', a: 'Dimensions : 350 × 89 × 15 cm, pensé pour une pratique en eau plate.' },
      { q: 'Que contient le pack ?', a: 'Planche gonflable, pagaie, ailerons, leash, sac étanche, pompe à main et sac à dos de transport.' },
      { q: 'Convient-il aux débutants ?', a: 'Ce paddle est de niveau intermédiaire : il s\'adresse aux pratiquants ayant déjà quelques sorties à leur actif et souhaitant progresser en eau plate.' },
      FAQ_INFLATE_PADDLE
    ]),
    'kayak-gonflable-1-place': faq([
      { q: 'Comment est construit ce kayak ?', a: 'Kayak gonflable 1 place : 3 chambres à air indépendantes, plancher drop-stitch rigide (gonflage 6-8 PSI), chambres latérales (2-2,5 PSI), coque épaissie et poignées de transport.' },
      { q: 'Que contient le pack ?', a: 'Kayak gonflable, 1 pagaie démontable, 1 siège rembourré, 3 ailerons, pompe double action, kit de réparation et sac de transport.' },
      { q: 'Peut-on l\'utiliser pour la pêche ?', a: 'Oui, ce kayak gonflable convient à la balade, à la randonnée nautique et à la pêche sur plans d\'eau calmes.' },
      { q: 'Comment le gonfler ?', a: 'Avec la pompe double action fournie dans le pack : 6-8 PSI pour le plancher drop-stitch et 2-2,5 PSI pour les chambres latérales, sans accessoire supplémentaire.' }
    ]),
    'kayak-gonflable-2-places-bleu': faq([
      { q: 'Comment est construit ce kayak ?', a: 'Kayak gonflable 2 places : 3 chambres à air indépendantes, plancher drop-stitch rigide (gonflage 6-8 PSI), chambres latérales (2-2,5 PSI), coque épaissie et poignées de transport.' },
      { q: 'Que contient le pack ?', a: 'Kayak gonflable, 2 pagaies démontables, 2 sièges rembourrés, 3 ailerons, pompe double action, kit de réparation et sac de transport.' },
      { q: 'Peut-on l\'utiliser pour la pêche ?', a: 'Oui, ce kayak gonflable convient à la balade, à la randonnée nautique et à la pêche sur plans d\'eau calmes.' },
      { q: 'Comment le gonfler ?', a: 'Avec la pompe double action fournie dans le pack : 6-8 PSI pour le plancher drop-stitch et 2-2,5 PSI pour les chambres latérales, sans accessoire supplémentaire.' }
    ]),
    'kayak-gonflable-2-places-rouge': faq([
      { q: 'Comment est construit ce kayak ?', a: 'Kayak gonflable 2 places : 3 chambres à air indépendantes, plancher drop-stitch rigide (gonflage 6-8 PSI), chambres latérales (2-2,5 PSI), coque épaissie et poignées de transport.' },
      { q: 'Que contient le pack ?', a: 'Kayak gonflable, 2 pagaies démontables, 2 sièges rembourrés, 3 ailerons, pompe double action, kit de réparation et sac de transport.' },
      { q: 'Peut-on l\'utiliser pour la pêche ?', a: 'Oui, ce kayak gonflable convient à la balade, à la randonnée nautique et à la pêche sur plans d\'eau calmes.' },
      { q: 'Comment le gonfler ?', a: 'Avec la pompe double action fournie dans le pack : 6-8 PSI pour le plancher drop-stitch et 2-2,5 PSI pour les chambres latérales, sans accessoire supplémentaire.' }
    ])
  };

  function ntyHandleFromPath(){
    try{
      var m = location.pathname.match(/\/products\/([^\/?#]+)/);
      return m ? decodeURIComponent(m[1]) : null;
    }catch(e){ return null; }
  }

  function escHtml(s){
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function rebuildFaq(){
    try{
      if(has('nofaq')) return;
      var handle = ntyHandleFromPath();
      if(!handle) return;
      var items = FAQ_BASIC;
      if(!items || !items.length) return;
      var containers = document.querySelectorAll('[class*="mz-faq"]');
      for(var c=0;c<containers.length;c++){
        var cont = containers[c];
        var existing = cont.querySelectorAll('[class*="mz-faq-item"]');
        if(!existing.length) continue;
        if(cont.dataset.ntyFaqBuilt === handle) continue;
        var template = existing[0].cloneNode(true);
        var parent = existing[0].parentNode;
        for(var e=0;e<existing.length;e++){ if(existing[e].parentNode) existing[e].parentNode.removeChild(existing[e]); }
        for(var i=0;i<items.length;i++){
          var node = template.cloneNode(true);
          node.classList.remove('nty-faq-open');
          node.classList.remove('is-open','active','open');
          var qText = node.querySelector('[class*="mz-faq-question-text"]');
          if(qText){ qText.textContent = items[i].q; }
          else {
            var qEl = node.querySelector('[class*="mz-faq-question"]');
            if(qEl){ qEl.textContent = items[i].q; }
          }
          var ansInner = node.querySelector('[class*="mz-faq-answer-inner"]');
          if(ansInner){ ansInner.innerHTML = '<p>'+escHtml(items[i].a)+'</p>'; }
          else {
            var ans = node.querySelector('[class*="mz-faq-answer"]');
            if(ans){ ans.innerHTML = '<p>'+escHtml(items[i].a)+'</p>'; }
          }
          var ansEl = node.querySelector('[class*="mz-faq-answer"]');
          if(ansEl){ ansEl.style.removeProperty('display'); }
          parent.appendChild(node);
        }
        cont.dataset.ntyFaqBuilt = handle;
      }
      bindFaqToggle();
    }catch(e){}
  }

  function bindFaqToggle(){
    if(window.__ntyFaqToggleBound) return;
    window.__ntyFaqToggleBound = true;
    document.addEventListener('click', function(ev){
      try{
        var t = ev.target;
        if(!t || !t.closest) return;
        var q = t.closest('[class*="mz-faq-question"]');
        if(!q) return;
        var item = q.closest('[class*="mz-faq-item"]');
        if(!item) return;
        var cont = item.closest('[data-nty-faq-built]');
        if(!cont) return;
        ev.preventDefault();
        var willOpen = !item.classList.contains('nty-faq-open');
        item.classList.toggle('nty-faq-open', willOpen);
        var ans = item.querySelector('[class*="mz-faq-answer"]');
        if(ans){
          if(willOpen){
            ans.style.setProperty('display','block','important');
            ans.style.setProperty('max-height','none','important');
            ans.style.setProperty('overflow','visible','important');
          } else {
            ans.style.removeProperty('max-height');
            ans.style.removeProperty('overflow');
            ans.style.setProperty('display','none','important');
          }
        }
      }catch(e){}
    }, true);
  }

  /* 03/09 — killVSnap balayait TOUTE la page (getComputedStyle sur chaque
     element, ~200 ms) a chaque mutation du DOM : c'etait la tache longue qui
     saccadait dots, packs et animations. Desormais : un element n'est verifie
     qu'UNE fois (WeakSet), et l'observateur ne passe que les noeuds AJOUTES. */
  var vsnapVu = (typeof WeakSet === 'function') ? new WeakSet() : null;
  function killVSnap(racines){
    try{
      var liste = [];
      if (racines && racines.length) {
        for (var r = 0; r < racines.length; r++) {
          var n = racines[r]; if (!n || n.nodeType !== 1) continue;
          liste.push(n); var sub = n.querySelectorAll('*'); for (var q = 0; q < sub.length; q++) liste.push(sub[q]);
        }
      } else { liste = document.querySelectorAll('*'); }
      for(var i=0;i<liste.length;i++){ var el = liste[i];
        if (vsnapVu) { if (vsnapVu.has(el)) continue; vsnapVu.add(el); }
        var t=window.getComputedStyle(el).scrollSnapType;
        if(t && t!=='none' && (/\by\b/.test(t) || /both/.test(t))){ el.style.setProperty('scroll-snap-type','none','important'); } }
    }catch(e){}
  }
  killVSnap();
  window.addEventListener('load', killVSnap);
  [400,1200,3000].forEach(function(ms){ setTimeout(killVSnap, ms); });
  var ki=false; function onInteract(){ if(ki) return; ki=true; killVSnap(); }
  window.addEventListener('touchstart', onInteract, {passive:true});
  window.addEventListener('scroll', onInteract, {passive:true});

  try{ var de=document.documentElement;
    if(has('nodesc')) de.setAttribute('data-nty-nodesc','1');
    if(has('noavis')||has('noreviews')) de.setAttribute('data-nty-noavis','1');
    if(has('noavisline')) de.setAttribute('data-nty-noavisline','1');
    if(has('notaille')) de.setAttribute('data-nty-notaille','1');
    if(has('norecos')) de.setAttribute('data-nty-norecos','1');
    if(has('nosticky')) de.setAttribute('data-nty-nosticky','1');
    if(has('nopack')) de.setAttribute('data-nty-nopack','1');
    if(has('noconseils')) de.setAttribute('data-nty-noconseils','1');
    if(has('nospecs')) de.setAttribute('data-nty-nospecs','1');
    if(has('noeditorial')) de.setAttribute('data-nty-noeditorial','1');
    if(has('noenh')) de.setAttribute('data-nty-noenh','1');
  }catch(e){}

  function ntyShowSlide(suffix, idx){
    try{
      idx = String(idx);
      var mains = document.querySelectorAll('[id^="mzMainImg-'+suffix+'-"]');
      for(var i=0;i<mains.length;i++){
        var el = mains[i];
        var mm = el.id.match(/-(\d+)$/);
        if(!mm) continue;
        if(mm[1] === idx){
          el.style.setProperty('display','block','important');
          el.style.setProperty('position','relative','important');
        } else {
          el.style.setProperty('display','none','important');
          el.style.setProperty('position','absolute','important');
        }
      }
      var thumbs = document.querySelectorAll('[id^="mzThumb-'+suffix+'-"]');
      for(var j=0;j<thumbs.length;j++){
        var tm = thumbs[j].id.match(/-(\d+)$/);
        if(!tm) continue;
        thumbs[j].classList.toggle('active', tm[1] === idx);
      }
      try{
        var dots = document.querySelectorAll('[data-index].mz-dot, .mz-dot[data-index]');
        for(var d=0;d<dots.length;d++){
          dots[d].classList.toggle('active', String(dots[d].getAttribute('data-index'))===idx);
        }
      }catch(e){}
    }catch(e){}
  }

  function ntyCurrentIndex(suffix){
    try{
      var mains = document.querySelectorAll('[id^="mzMainImg-'+suffix+'-"]');
      for(var i=0;i<mains.length;i++){
        var cs = window.getComputedStyle(mains[i]);
        if(cs.display !== 'none'){
          var mm = mains[i].id.match(/-(\d+)$/);
          if(mm) return parseInt(mm[1],10);
        }
      }
    }catch(e){}
    return 0;
  }

  function ntySuffixFromPage(){
    try{
      var any = document.querySelector('[id^="mzMainImg-"]');
      if(!any) return null;
      var m = any.id.match(/^mzMainImg-(.+)-\d+$/);
      return m ? m[1] : null;
    }catch(e){ return null; }
  }

  function bindGalleryNav(){
    if(window.__ntyGalleryNavBound) return;
    window.__ntyGalleryNavBound = true;
    document.addEventListener('click', function(ev){
      try{
        var t = ev.target;
        if(!t || !t.closest) return;
        var more = t.closest('[class*="mz-thumb-more"]');
        if(more){
          var sfx = ntySuffixFromPage();
          if(sfx){
            var total = document.querySelectorAll('[id^="mzMainImg-'+sfx+'-"]').length;
            if(total>0){
              var next = (ntyCurrentIndex(sfx)+1) % total;
              ntyShowSlide(sfx, next);
            }
          }
          return;
        }
        var thumb = t.closest('[id^="mzThumb-"]');
        if(thumb && thumb.id && thumb.hasAttribute('data-index')){
          var m = thumb.id.match(/^mzThumb-(.+)-(\d+)$/);
          if(m){ ntyShowSlide(m[1], m[2]); }
        }
      }catch(e){}
    }, true);
  }
  bindGalleryNav();
  document.addEventListener('DOMContentLoaded', bindGalleryNav);
  window.addEventListener('load', bindGalleryNav);

  function injectDescImage(){
    try{
      if(has('nodesc')||has('noenh')) return;
      if(window.innerWidth<=768) return;
      var sec=document.getElementById('mz-product-description'); if(!sec) return;
      var inner=sec.querySelector('.nty-desc__inner'); if(!inner) return;
      if(inner.querySelector('#nty-desc-img-el')) return;
      var holder=document.getElementById('nty-desc-img');
      var src=holder ? holder.getAttribute('data-src') : '';
      if(!src) return;
      var textWrap=document.createElement('div');
      textWrap.className='nty-desc__text';
      while(inner.firstChild){ textWrap.appendChild(inner.firstChild); }
      inner.appendChild(textWrap);
      var img=document.createElement('img');
      img.id='nty-desc-img-el';
      img.src=src;
      img.alt='';
      img.loading='lazy';
      inner.appendChild(img);
      inner.classList.add('nty-desc--2col');
    }catch(e){}
  }

  function styleReviewStars(){
    try{
      var lines=document.querySelectorAll('[class*="nty-reviews-line"]');
      for(var i=0;i<lines.length;i++){
        var line=lines[i];
        var nodes=line.querySelectorAll('span,i,em,b');
        for(var j=0;j<nodes.length;j++){
          var txt=(nodes[j].textContent||'');
          if(/[★☆]/.test(txt)){
            nodes[j].style.setProperty('color','#111','important');
            nodes[j].style.setProperty('font-size','13px','important');
            nodes[j].style.setProperty('letter-spacing','1px','important');
            nodes[j].style.setProperty('line-height','1','important');
            nodes[j].style.setProperty('vertical-align','middle','important');
            if(/☆/.test(txt) && !nodes[j].dataset.ntyStarFilled){
              nodes[j].textContent=txt.replace(/☆/g,'★');
              nodes[j].dataset.ntyStarFilled='1';
            }
          }
        }
      }
    }catch(e){}
  }

  function injectDemoPromo(){
    try{
      var blocks=document.querySelectorAll('[class*="mz-price-block"]');
      for(var i=0;i<blocks.length;i++){
        var blk=blocks[i];
        if(blk.dataset.ntyDemoPromo==='1') continue;
        var raw=(blk.textContent||'');
        var m=raw.match(/(\d[\d\s.,]*)\s*€?/);
        if(!m) continue;
        var numStr=m[1].replace(/\s/g,'').replace(/\.(?=\d{3}\b)/g,'').replace(',', '.');
        var current=parseFloat(numStr);
        if(!isFinite(current) || current<=0) continue;
        var oldPrice=Math.round(current/(1-0.26));
        var pct=Math.round((oldPrice-current)/oldPrice*100);
        blk.dataset.ntyDemoPromo='1';
        var cmp=document.createElement('span');
        cmp.className='nty-demo-compare';
        cmp.textContent=oldPrice+'€';
        var badge=document.createElement('span');
        badge.className='nty-demo-badge';
        badge.textContent='-'+pct+'%';
        blk.appendChild(cmp);
        blk.appendChild(badge);
      }
    }catch(e){}
  }

  function injectSizeGuide(){
    try{
      var blocks=document.querySelectorAll('.nty-size-block');
      for(var i=0;i<blocks.length;i++){
        var blk=blocks[i];
        if(blk.querySelector('.nty-size-guide-link')) continue;
        var link=document.createElement('a');
        link.className='nty-size-guide-link';
        link.href='/pages/guide-achat';
        link.textContent='Guide des tailles';
        var head=null, kids=blk.children;
        for(var k=0;k<kids.length;k++){
          var tx=(kids[k].textContent||'').trim().toLowerCase();
          if(tx.indexOf('taille')===0 || tx==='taille'){ head=kids[k]; break; }
        }
        if(head){ head.classList.add('nty-size-head'); head.appendChild(link); }
        else { blk.style.position=blk.style.position||'relative'; link.style.position='absolute'; link.style.top='8px'; link.style.right='10px'; blk.appendChild(link); }
      }
    }catch(e){}
  }

  /* ============================================================
     (15) POST-TRAITEMENT DE LA SECTION AVIS #nty-reviews (demo)
     La section est construite en async par un autre snippet ;
     ces fonctions sont idempotentes et rappelees par apply()
     via le MutationObserver.
     ============================================================ */

  /* Lecture des URLs d'images produit reelles emises par Liquid */
  function ntyRevPhotos(){
    try{
      if(window.__ntyRevPhotos) return window.__ntyRevPhotos;
      var el=document.getElementById('nty-rev-photos');
      var arr=[];
      if(el){ try{ arr=JSON.parse(el.textContent||'[]')||[]; }catch(e){ arr=[]; } }
      arr=arr.filter(function(u){ return u && typeof u==='string'; });
      window.__ntyRevPhotos=arr;
      return arr;
    }catch(e){ return []; }
  }

  /* Lightbox construite une seule fois */
  function ntyEnsureLightbox(){
    if(document.getElementById('nty-lightbox')) return;
    var lb=document.createElement('div');
    lb.id='nty-lightbox';
    lb.innerHTML='<button class="nty-lightbox__close" aria-label="Fermer">&times;</button><img alt="">';
    document.body.appendChild(lb);
    function close(){ lb.classList.remove('is-open'); var im=lb.querySelector('img'); if(im) im.removeAttribute('src'); }
    lb.addEventListener('click', function(ev){ if(ev.target===lb || ev.target.classList.contains('nty-lightbox__close')) close(); });
    document.addEventListener('keydown', function(ev){ if(ev.key==='Escape' && lb.classList.contains('is-open')) close(); });
  }
  function ntyOpenLightbox(src){
    ntyEnsureLightbox();
    var lb=document.getElementById('nty-lightbox');
    var im=lb.querySelector('img');
    if(im){ im.src=src; }
    lb.classList.add('is-open');
  }

  /* (15a) PHOTOS D'AVIS — DEMO (images produit reutilisees), a remplacer par de
     vraies photos d'avis via une app. Ajoute une rangee de 2-3 vignettes cliquables
     aux 2-3 premieres cartes .nty-review, sous le texte. Structure prete a recevoir
     de vraies photos plus tard (conteneur .nty-review__photos). Idempotent. */
  function injectReviewPhotos(){
    try{
      if(has('noavis')||has('noreviews')||has('noenh')) return;
      var sec=document.getElementById('nty-reviews'); if(!sec) return;
      var cards=sec.querySelectorAll('.nty-review');
      if(!cards.length) return;
      var photos=ntyRevPhotos();
      if(!photos.length) return;
      ntyEnsureLightbox();
      var maxCards=Math.min(3, cards.length);
      for(var c=0;c<maxCards;c++){
        var card=cards[c];
        if(card.dataset.ntyRevPhotos==='1') continue;
        card.dataset.ntyRevPhotos='1';
        var n=Math.min(3, Math.max(2, photos.length));
        var wrap=document.createElement('div');
        wrap.className='nty-review__photos';
                var row=document.createElement('div');
        row.className='nty-review__photos-row';
        for(var p=0;p<n;p++){
          var src=photos[(c+p)%photos.length];
          var img=document.createElement('img');
          img.className='nty-review__photo';
          img.src=src;
          img.alt='';
          img.loading='lazy';
          img.setAttribute('data-full', src);
          (function(fullSrc){
            img.addEventListener('click', function(){ ntyOpenLightbox(fullSrc); });
          })(src);
          row.appendChild(img);
        }
        wrap.appendChild(row);
        card.appendChild(wrap);
      }
    }catch(e){}
  }

  /* (15d) TRI FONCTIONNEL sur les cartes demo */
  var NTY_FR_MONTHS={ 'janvier':0,'fevrier':1,'février':1,'mars':2,'avril':3,'mai':4,'juin':5,'juillet':6,'aout':7,'août':7,'septembre':8,'octobre':9,'novembre':10,'decembre':11,'décembre':11 };
  function ntyParseCardRating(card){
    try{
      var txt=card.textContent||'';
      var filled=(txt.match(/★/g)||[]).length;
      return filled;
    }catch(e){ return 0; }
  }
  function ntyParseCardDate(card){
    try{
      var txt=(card.textContent||'').toLowerCase();
      var m=txt.match(/(\d{1,2})\s+([a-zàâäéèêëîïôöûüç]+)\s+(\d{4})/);
      if(!m) return 0;
      var day=parseInt(m[1],10);
      var mon=NTY_FR_MONTHS[m[2]];
      var year=parseInt(m[3],10);
      if(mon==null||!isFinite(day)||!isFinite(year)) return 0;
      return new Date(year,mon,day).getTime();
    }catch(e){ return 0; }
  }
  var NTY_SORT_OPTS=[
    { key:'pertinents', label:'Plus pertinents' },
    { key:'recents',    label:'Plus récents' },
    { key:'meilleures', label:'Meilleures notes' },
    { key:'basses',     label:'Notes les plus basses' }
  ];
  function ntyApplySort(list, key){
    try{
      var cards=Array.prototype.slice.call(list.querySelectorAll('.nty-review'));
      if(!cards.length) return;
      /* cache de l'ordre initial (pertinence) au premier passage */
      cards.forEach(function(cd,i){ if(cd.dataset.ntyOrder==null) cd.dataset.ntyOrder=String(i); });
      var data=cards.map(function(cd){
        return { node:cd, order:parseInt(cd.dataset.ntyOrder,10)||0, rating:ntyParseCardRating(cd), date:ntyParseCardDate(cd) };
      });
      if(key==='recents'){ data.sort(function(a,b){ return b.date-a.date; }); }
      else if(key==='meilleures'){ data.sort(function(a,b){ return (b.rating-a.rating)||(b.date-a.date); }); }
      else if(key==='basses'){ data.sort(function(a,b){ return (a.rating-b.rating)||(b.date-a.date); }); }
      else { data.sort(function(a,b){ return a.order-b.order; }); }
      data.forEach(function(d){ list.appendChild(d.node); });
    }catch(e){}
  }
  function bindReviewSort(){
    try{
      if(has('noavis')||has('noreviews')||has('noenh')) return;
      var sec=document.getElementById('nty-reviews'); if(!sec) return;
      var sort=sec.querySelector('.nty-reviews__sort'); if(!sort) return;
      var list=sec.querySelector('.nty-reviews__list'); if(!list) return;
      if(sort.dataset.ntySortBound==='1') return;
      sort.dataset.ntySortBound='1';
      var menu=document.createElement('div');
      menu.className='nty-sort-menu';
      NTY_SORT_OPTS.forEach(function(opt){
        var b=document.createElement('button');
        b.type='button';
        b.textContent=opt.label;
        b.setAttribute('data-key', opt.key);
        if(opt.key==='pertinents') b.classList.add('is-active');
        menu.appendChild(b);
      });
      sort.appendChild(menu);
      var baseLabel='Trier par : ';
      function setLabel(txt){
        /* met a jour le texte du controle sans supprimer le menu */
        var walker=document.createTreeWalker(sort, NodeFilter.SHOW_TEXT, null);
        var tn=walker.nextNode();
        if(tn){ tn.nodeValue=baseLabel+txt; }
      }
      sort.addEventListener('click', function(ev){
        if(ev.target.closest('.nty-sort-menu')) return;
        ev.preventDefault(); ev.stopPropagation();
        menu.classList.toggle('is-open');
      });
      menu.addEventListener('click', function(ev){
        var b=ev.target.closest('button[data-key]'); if(!b) return;
        ev.preventDefault(); ev.stopPropagation();
        var key=b.getAttribute('data-key');
        ntyApplySort(list, key);
        Array.prototype.forEach.call(menu.querySelectorAll('button'), function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
        setLabel(b.textContent.toLowerCase());
        menu.classList.remove('is-open');
      });
      document.addEventListener('click', function(ev){
        if(!sort.contains(ev.target)) menu.classList.remove('is-open');
      });
    }catch(e){}
  }

  /* (15) pills : simple toggle d'etat actif (pas de filtrage reel requis) */
  function bindReviewPills(){
    try{
      var sec=document.getElementById('nty-reviews'); if(!sec) return;
      if(sec.dataset.ntyPillsBound==='1') return;
      var pills=sec.querySelectorAll('.nty-reviews__pill');
      if(!pills.length) return;
      sec.dataset.ntyPillsBound='1';
      Array.prototype.forEach.call(pills, function(pill){
        pill.addEventListener('click', function(){
          Array.prototype.forEach.call(pills, function(x){ x.classList.remove('nty-pill-active'); });
          pill.classList.add('nty-pill-active');
        });
      });
      if(pills[0]) pills[0].classList.add('nty-pill-active');
    }catch(e){}
  }

  function enhanceReviews(){
    injectReviewPhotos();
    bindReviewSort();
    bindReviewPills();
  }

  function apply(){
    try{
      if(has('nodesc')){ var d=document.getElementById('mz-product-description'); if(d) d.style.display='none'; }
      if(has('noavis')||has('noreviews')){ var r=document.getElementById('nty-reviews'); if(r) r.style.display='none'; var ll=document.querySelectorAll('[class*="nty-reviews-line"]'); for(var i=0;i<ll.length;i++) ll[i].style.display='none'; }
      if(has('noavisline')){ var al=document.querySelectorAll('[class*="nty-reviews-line"]'); for(var a=0;a<al.length;a++) al[a].style.display='none'; }
      if(has('notaille')){ var tb=document.querySelectorAll('.nty-size-block'); for(var t=0;t<tb.length;t++) tb[t].style.display='none'; }
      if(has('norecos')){ var rc=document.getElementById('nty-reco'); if(rc) rc.style.display='none'; }
      if(has('nosticky')){ var ss=document.querySelectorAll('[class*="mz-sticky-atc"]'); for(var j=0;j<ss.length;j++) ss[j].style.display='none'; }
      if(has('nopack')){ var ps=document.querySelectorAll('.features-list.nty-pack'); for(var kk=0;kk<ps.length;kk++) ps[kk].style.display='none'; }
      if(has('noconseils')){ var nc=document.getElementById('nty-conseils'); if(nc) nc.style.display='none'; }
      if(has('nospecs')){ var nsp=document.getElementById('nty-specs'); if(nsp) nsp.style.display='none'; }
      if(has('noeditorial')){ var ned=document.getElementById('nty-editorial'); if(ned) ned.style.display='none'; }
      if(has('noenh')){ ['nty-reco','nty-conseils','nty-specs','nty-editorial'].forEach(function(id){ var e=document.getElementById(id); if(e) e.style.display='none'; }); }
      if(has('novideo')){ var stl=document.querySelector('.stl-carousel,[class*="stl-fs"]'); if(stl){ var sec=stl.closest('[id^="shopify-section"]'); if(sec) sec.style.display='none'; } }
      injectSizeGuide();
      injectDescImage();
      styleReviewStars();
      injectDemoPromo();
      rebuildFaq();
      enhanceReviews();
    }catch(e){}
  }
  document.addEventListener('DOMContentLoaded', apply);
  window.addEventListener('load', apply);
  var tmr=null; var ajoutes=[];
  var mo=new MutationObserver(function(recs){
    for (var i = 0; i < recs.length; i++) { var an = recs[i].addedNodes; for (var j = 0; j < an.length; j++) { if (an[j].nodeType === 1) ajoutes.push(an[j]); } }
    if(tmr) clearTimeout(tmr); tmr=setTimeout(function(){ var lot = ajoutes; ajoutes = []; apply(); killVSnap(lot); bindGalleryNav(); },180); });
  document.addEventListener('DOMContentLoaded', function(){ try{ mo.observe(document.body,{childList:true,subtree:true}); }catch(e){} });
  apply();
}());
